<template>
  <div class="joinUs">
    <header-mod :page-name="'joinUs'"></header-mod>

    <div class="page">
      <div class="page_title">加入我们</div>
      <div class="join_box">
        <div class="title">团队长 / 业务经理</div>
        <div class="contact_msg">
          <div class="join_city">
            <img src="../assets/imgs/icon_ping.png" alt="">
            <div class="city">
              <div class="tit">工作地点：</div>
              <div class="txt">广东、北京、上海、浙江、山东、天津、重庆、广西、山西、陕西、湖南、湖北、河南、河北、江苏、福建、安徽、江西、四川、贵州、云南、海南、甘肃、宁夏、青海、内蒙古</div>
            </div>
          </div>

          <div class="content">
            <p class="point">岗位职责：</p>
            <p class="request">1、负责公司产品推广，开拓新市场，发展新客户；</p>
            <p class="request">2、为客户提供贷款方案，及时解决客户需求，管理维护客户关系以及客户间的长期合作规划。</p>
            <p class="point">任职资格：</p>
            <p class="request">1、大专及以上学历，年龄22-45岁；</p>
            <p class="request">2、供应链金融、银行、保险、快消、小微信贷等从业经历者优先；</p>
            <p class="request">3、具备一定拓展市场能力及分析判断能力，有良好的客户服务意识；</p>
            <p class="request">4、有责任心、具备较强的业务拓展能力，能吃苦耐劳。</p>
            <p class="point">福利待遇：</p>
            <p class="request"> <span>六险一金</span> <span>带薪年假</span> <span>绩效高配</span> <span>前景广阔</span> <span>持续晋升</span> </p>
            <p class="request"> <span>导师辅导</span> <span>多元培训</span> <span>项目历练</span> <span>技能提升</span> <span>机制灵活</span> </p>
            <div class="tips">
              <p class="tip">2025寻找发光的你，快来怡信大展宏“兔”！</p>
              <p class="email">怡亚数科期待您的加入，简历请投至邮箱：heying@eadigits.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer-mod></footer-mod>
  </div>
</template>

<script>
import headerMod from "@/components/header"
import footerMod from "@/components/footer"
export default {
  components: {
    HeaderMod: headerMod,
    FooterMod: footerMod
  },
  data() {
    return {

    }
  },
  methods: {

  },
  created() {
    document.title = '加入我们 - 怡信未来'
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/joinUs.vue